<div class="w-full border border-gray-200 rounded-lg py-2 px-4 flex justify-between items-center">
  <div>
    <div class="text-sm text-gray-500">Status APK Webhook</div>
    <span class="font-semibold text-base" [ngClass]="isActived() ? 'text-[#00B140]' : 'text-[#E31A1A]'">{{ isActived() ? 'Activated' : 'Unactivated' }}</span>
  </div>
  <div>
    <button nz-button class="w-10 h-10 p-0 flex items-center justify-center border-0" [ngClass]="isActived() ? 'bg-[#DCF3EB]' : 'bg-[#FFEDED]'">
      <img [src]="isActived() ? 'https://storage.googleapis.com/komerce/assets/icons/mobile-green.svg' : 'https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/mobile.svg'" alt="mobile" class="w-5 h-5">
    </button>
  </div>
</div>

@if (isActived()) {
  <div class="w-full flex flex-col md:flex-row gap-4 justify-between items-start border border-gray-200 rounded-lg py-4 px-4 mt-4 bg-[#DCF3EB]/25">
    <div class="flex flex-col gap-1 text-[#34A770]">
      <span class="font-semibold text-base">✅ APK Webhook Configuration Activated</span>
      <div class="flex items-center gap-2">
        <span class="font-semibold">ID:</span>
        <span>{{ secretKeyData()?.user_uuid }}</span>
      </div>
      <div class="flex items-center gap-2">
        <span class="font-semibold">Secret Key:</span>
        <span>{{ secretKeyData()?.secret_key?.slice(35) }}</span>
      </div>
      <div class="flex items-center gap-2">
        <span class="font-semibold">Created:</span>
        <span>{{ (secretKeyData()?.created_at | date: 'dd MMMM yyyy') || '  -' }}</span>
      </div>
      <div class="flex items-center gap-2">
        <span class="font-semibold">Updated:</span>
        <span>{{ (secretKeyData()?.updated_at | date: 'dd MMMM yyyy') || '-' }}</span>
      </div>
    </div>

    <div class="flex flex-col lg:flex-row gap-2 mt-2 w-full md:w-auto">
      <button nz-button nzType="text" class="flex items-center justify-center lg:justify-start gap-2 h-10 text-gray-700 w-full sm:w-auto" (click)="openModal()">
        <img src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/key.svg" alt="key" class="w-5 h-5 opacity-70">
        Regenerate
      </button>
      <button nz-button class="flex items-center justify-center lg:justify-start gap-2 h-10 bg-error hover:bg-error hover:text-white! text-white w-full sm:w-auto" (click)="handleDeactivate()">
        <img src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/trash.svg" alt="trash" class="w-5 h-5">
        Deactivate
      </button>
    </div>
  </div>

  <div class="w-full border border-gray-200 rounded-lg py-2 px-4 mt-4">
    <span class="text-sm text-gray-500">
      Webhook URL (for APK Listener)
    </span>

    <div class="flex items-center gap-2">
      <nz-input-group [nzPrefix]="prefixTemplate" class="w-full">
        <input
          type="text"
          nz-input
          placeholder="Webhook URL"
          [ngModel]="webhookUrl()"
          readonly
          class="rounded-lg h-9 border-gray-300 cursor-default"
        />
        <ng-template #prefixTemplate>
          <img src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/link-2.svg" alt="link" class="w-5 h-5 opacity-70">
        </ng-template>
      </nz-input-group>

      <button nz-button nzType="text" class="flex items-center gap-2" (click)="copyToClipboard(secretKeyData()?.webhook_url)">
        <i class="icon-copy text-gray-500" ></i>
        <span class="text-gray-500">Copy URL</span>
      </button>
    </div>
  </div>

  <div class="w-full border border-gray-200 bg-[#F8F8F8] rounded-lg py-2 px-4 mt-4 flex flex-col gap-2">
    <span class="text-sm text-gray-500 font-semibold">📱 Mobile Application</span>
    <span class="text-sm text-gray-500">Download the mobile app to manage your webhooks and monitor payment activity.</span>

    <button nz-button nzType="text" class="flex items-center gap-2 h-10 w-fit" (click)="downloadAPK()">
      <img src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/import-2.svg" alt="add" class="w-5 h-5">
      Download APK Listener
    </button>
  </div>
} @else {
  <div class="flex flex-col justify-center items-center mt-4 gap-2">
    <img src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/mobile.svg" alt="mobile" class="w-5 h-5">
    <span class="font-semibold">No Webhook Configuration Yet</span>
    <span class="text-sm text-gray-500">Set up a webhook to receive payment notifications from the mobile app.</span>

    <button nz-button nzType="primary" class="flex items-center gap-2 mt-4 h-10" (click)="openModal()">
      <img src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/add.svg" alt="add" class="w-5 h-5">
      Generate Configuration
    </button>
  </div>
}

<app-modal-generate-config [isVisible]="isModalGenerateConfigVisible()" [secretKeyData]="secretKeyData()" (isVisibleChange)="isModalGenerateConfigVisible.set($event); getSecretKey()"></app-modal-generate-config>
<app-download-apk-modal [isVisible]="isDownloadApkModalVisible()" (isVisibleChange)="isDownloadApkModalVisible.set($event)"></app-download-apk-modal>
